import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-factory-pool',
  templateUrl: './factory-pool.component.html',
  styleUrls: ['./factory-pool.component.css']
})
export class FactoryPoolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
